export default "__VITE_PUBLIC_ASSET__6fb27e9e__"